import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Products } from '../data/products'
import emailjs from '@emailjs/browser';
import { SERVICE_ID, TEMPLATE_ID, PUBLIC_ID } from '../data/constant';
import Related from '../component/card/related';
import Slider from 'react-slick/lib/slider';
import Sliders from '../component/slicker';

function Product() {
    const {slug} = useParams()
    const [product, setProduct] = useState()
    const initial = {name:'', email:'', phone:'', qty:0, location:''}
    const [formData, setFormData] = useState(initial)
    const [loading, setLoading] = useState(false)
    const [active, setActive] = useState(0)
    const [others, setOthers] = useState()
    const related = others?.filter((item) => item.slug !== slug).slice(0,7)

    useEffect(() => {
        let isMounted = true
        const controller = new AbortController()
        const fetchData = async () => {
            const response = await fetch('https://6cbl05gmqj.execute-api.us-east-1.amazonaws.com/api/v1/products/by-identity?identity='+slug)
            if (response && response.ok){
                const data = await response.json()
                setProduct(data.response)
            }
        }
        fetchData()
    }, [slug])

    useEffect(() => {
        let isMounted = true
        const controller = new AbortController()
        const fetchData = async () => {
            const response = await fetch('https://6cbl05gmqj.execute-api.us-east-1.amazonaws.com/api/v1/products')
            if (response && response.ok) {
                const data = await response.json()
                if (isMounted){
                    setOthers(data.response)
                }
            }
        }
        fetchData()
        return () => {
            isMounted = false
            controller.abort()
        }
    },[slug])

    const onChangeValue = (e) => {
        setFormData({
            ...formData,
            [e.target.name]:e.target.value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            formData.product = product.name
            const response = await emailjs.send(
                SERVICE_ID,
                TEMPLATE_ID,
                {data:formData},
                PUBLIC_ID
            )
            if (response && response.status == 200){
                const message = `Hello Admin! \n My name is ${formData.name}, I'd like to make inquiry about ${product.name}`
                const url = `https://wa.me/09056006878?text=${encodeURIComponent(message)}`
                window.location.href=url
            }
            setFormData(initial)
            setLoading(false)
        } catch(err){
            console.log(err)
        }
        
    }

  return (
    <div class="section product-page-section">
        <div class="container">
            <div class="commerce-toolbar">
                <nav class="breadcrumb has-bullet-separator" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <Link to="/">
                                <span class="icon is-small is-solo">
                                    <i data-feather="home"></i>
                                </span>
                            </Link>
                        </li>
                        
                        
                        <li>
                            <a href="#">
                                <span>{product?.category}</span>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <span>{product?.name}</span>
                            </a>
                        </li>
                    </ul>
                </nav>

                
            </div>

            <div class="product-page-v1">
                <div class="product-head">
                    <div class="left">
                        {product?.images.map((item, index) => (
                            <img className={`product-image ${index === active ? "is-active active": ""}`} data-image={"id"+index+1} src={item} data-demo-src={item} key={index} alt="" />
                        ))}
                        {/* <img class="product-image" data-image="red1" src="./../assets/img/products/product-image-1.png" data-demo-src="./../assets/img/products/product-image-1.png" alt="" />
                        <img class="product-image" data-image="red2" src="./../assets/img/products/product-image-2.png" data-demo-src="./../assets/img/products/product-image-2.png" alt="" />
                        <img class="product-image is-active active" data-image="red3" src="./../assets/img/products/product-image-3.png" data-demo-src="./../assets/img/products/product-image-3.png" alt="" /> */}

                        <div class="product-thumbs">
                            {product?.images.map((item, index) => (
                                <a className={`product-thumb ${index === active ? "is-active":""}`} onClick={() => setActive(index)}>
                                    <img data-image={"id"+index+1} className="active" src={item} key={index} alt="" />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div class="right">
                        <div class="product-description">
                            <span>{product?.category}</span>
                            <h1>
                                <span class="product-name">{product?.name} </span>
                                <span class="product-price">{product?.price}</span>
                            </h1>
                            <p dangerouslySetInnerHTML={{__html:product?.description}}></p>
                            
                        </div>

                         <div class="product-configuration">
                            {/* <div class="product-colors">
                                <span>Colors</span>

                                <div class="color-selector">
                                    <div>
                                        <input data-image="red.html" type="radio" id="red" name="color" value="red" checked />
                                        <label for="red">
                                            <span class="indicator">
                                                <i data-feather="check"></i>
                                            </span>
                                            <span></span>
                                        </label>
                                    </div>
                                    <div>
                                        <input data-image="blue.html" type="radio" id="blue" name="color" value="blue" />
                                        <label for="blue">
                                            <span class="indicator">
                                                <i data-feather="check"></i>
                                            </span>
                                            <span></span>
                                        </label>
                                    </div>
                                    <div>
                                        <input data-image="black.html" type="radio" id="black" name="color" value="black" />
                                        <label for="black">
                                            <span class="indicator">
                                                <i data-feather="check"></i>
                                            </span>
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                             <div class="product-options">
                                <span>Options</span>

                                <div class="option-selector">
                                    <button>Titanium</button>
                                    <button>Carbone</button>
                                    <button>Chrome</button>
                                </div>

                                <a href="#">
                                    <i data-feather="help-circle"></i>
                                    <span>How to configurate your headphones</span>
                                </a>
                            </div> */}
                        </div> 

                        <div class="columns is-vcentered">
                            <div class="component-block is-large mb-40">
                                <div class="level">
                                    <div class="level-item">
                                        <a class="button button-cta social-btn facebook"><i class="fa fa-facebook-f"></i> Share</a>
                                    </div>
                                    <div class="level-item">
                                        <a class="button button-cta social-btn twitter"><i class="fa fa-twitter"></i> Share</a>
                                    </div>
                                    <div class="level-item">
                                        <a class="button button-cta social-btn linkedin"><i class="fa fa-linkedin"></i> Share</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-body">
                    <div class="product-info">
                        <div class="navigation-tabs full-pills primary animated-tabs">
                            <div class="tabs">
                                <ul>
                                    <li class="tab-link is-active" data-tab="tab-g1">
                                        <a>Benefits</a>
                                    </li>
                                    <li class="tab-link" data-tab="tab-g2">
                                        <a>Prescriptions</a>
                                    </li>
                                    <li class="tab-link" data-tab="tab-g3">
                                        <a>Reviews</a>
                                    </li>
                                </ul>
                            </div>
                            <div id="tab-g1" class="navtab-content is-active">
                                <div class="content">
                                    <span dangerouslySetInnerHTML={{__html:product?.benefits}}></span>
                                </div>
                            </div>
                            <div id="tab-g2" class="navtab-content">
                                <span dangerouslySetInnerHTML={{__html:product?.prescription}}></span>
                            </div>
                            <div id="tab-g3" class="navtab-content">
                                <div class="content">
                                    <h4>Reviews</h4>

                                    <div class="product-reviews">
                                        <div class="product-review">
                                            <article class="media">
                                                <figure class="media-left">
                                                    <p class="image is-32x32">
                                                        <img class="is-rounded" src="https://via.placeholder.com/250x250" data-demo-src="assets/img/avatars/henry.jpg" />
                                                    </p>
                                                </figure>
                                                <div class="media-content">
                                                    <span>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                    </span>
                                                    <p>
                                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                                        elit. Proin ornare magna eros, eu pellentesque tortor
                                                        vestibulum ut. Maecenas non massa sem.
                                                    </p>
                                                </div>
                                            </article>
                                        </div>
                                        <div class="product-review">
                                            <article class="media">
                                                <figure class="media-left">
                                                    <p class="image is-32x32">
                                                        <img class="is-rounded" src="https://via.placeholder.com/250x250" data-demo-src="assets/img/avatars/elie.jpg" />
                                                    </p>
                                                </figure>
                                                <div class="media-content">
                                                    <span>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                    </span>
                                                    <p>
                                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                                        elit. Proin ornare magna eros, eu pellentesque tortor.
                                                    </p>
                                                </div>
                                            </article>
                                        </div>
                                        <div class="product-review">
                                            <article class="media">
                                                <figure class="media-left">
                                                    <p class="image is-32x32">
                                                        <img class="is-rounded" src="https://via.placeholder.com/250x250" data-demo-src="assets/img/avatars/anthony.jpg" />
                                                    </p>
                                                </figure>
                                                <div class="media-content">
                                                    <span>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star"></i>
                                                    </span>
                                                    <p>
                                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                                        elit. Proin ornare magna eros, eu pellentesque tortor
                                                        vestibulum ut.
                                                    </p>
                                                </div>
                                            </article>
                                        </div>
                                        <div class="product-review">
                                            <article class="media">
                                                <figure class="media-left">
                                                    <p class="image is-32x32">
                                                        <img class="is-rounded" src="https://via.placeholder.com/250x250" data-demo-src="assets/img/avatars/christina.jpg" />
                                                    </p>
                                                </figure>
                                                <div class="media-content">
                                                    <span>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                    </span>
                                                    <p>
                                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                                        elit.
                                                    </p>
                                                </div>
                                            </article>
                                        </div>
                                        <div class="product-review">
                                            <article class="media">
                                                <figure class="media-left">
                                                    <p class="image is-32x32">
                                                        <img class="is-rounded" src="https://via.placeholder.com/250x250" data-demo-src="assets/img/avatars/nick.jpg" />
                                                    </p>
                                                </figure>
                                                <div class="media-content">
                                                    <span>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                        <i class="fas fa-star highlighted"></i>
                                                    </span>
                                                    <p>
                                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                                        elit. Proin ornare magna eros, eu pellentesque tortor
                                                        vestibulum ut. Maecenas non massa sem.
                                                    </p>
                                                </div>
                                            </article>
                                        </div>
                                        <div class="product-review">
                                            <article class="media">
                                                <figure class="media-left">
                                                    <p class="image is-32x32">
                                                        <img class="is-rounded" src="https://via.placeholder.com/250x250" data-demo-src="assets/img/avatars/lakisha.jpg" />
                                                    </p>
                                                </figure>
                                                <div class="media-content">
                                                    <span>
                          <i class="fas fa-star highlighted"></i>
                          <i class="fas fa-star highlighted"></i>
                          <i class="fas fa-star highlighted"></i>
                          <i class="fas fa-star"></i>
                          <i class="fas fa-star"></i>
                        </span>
                                                    <p>
                                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                                        elit. Proin ornare magna eros, eu pellentesque tortor
                                                        vestibulum ut.
                                                    </p>
                                                </div>
                                            </article>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="product-meta">
                        <div class="content-wrapper has-margin-bottom">
                            <div class="columns is-vcentered form-wrapper">
                                <div class="column">
                                    <div class="side-title" style={{paddingBottom:"20px"}}>
                                        <h5 class="title is-5 is-spaced is-portrait-padded">
                                            Fill the form below to make an order
                                        </h5>
                                    </div>
                                    <div class="contact-form is-bigger">
                                        <form onSubmit={handleSubmit}>
                                            <div class="control-material is-primary">
                                                <input class="material-input" type="text" name="name" value={formData.name} onChange={onChangeValue} required />
                                                <span class="material-highlight"></span>
                                                <span class="bar"></span>
                                                <label>Full Name</label>
                                            </div>
                                            <div class="control-material is-primary">
                                                <input class="material-input" type="text" name="email" value={formData.email} onChange={onChangeValue} required />
                                                <span class="material-highlight"></span>
                                                <span class="bar"></span>
                                                <label>Email</label>
                                            </div>
                                            <div class="control-material is-primary">
                                                <input class="material-input" type="text" name="phone" value={formData.phone} onChange={onChangeValue} required />
                                                <span class="material-highlight"></span>
                                                <span class="bar"></span>
                                                <label>Phone</label>
                                            </div>
                                            <div class="control-material is-primary">
                                            <input class="material-input" type="number" name="qty" value={formData.qty} onChange={onChangeValue} required />
                                                <span class="material-highlight"></span>
                                                <span class="bar"></span>
                                                <label>Quantity </label>
                                            </div>
                                            <div class="control-material is-primary">
                                            <input class="material-input" type="text" name="location" value={formData.location} onChange={onChangeValue} required />
                                                <span class="material-highlight"></span>
                                                <span class="bar"></span>
                                                <label>Location </label>
                                            </div>
                                            <div class="button-wrap">
                                                <button type="submit" class="button button-cta primary-btn btn-align no-lh raised is-fullwidth">
                                                    {loading ? 'Sending...' : 'Order Now'}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div class="flex-card simple-shadow">
                            <div class="card-body">
                                <div class="content">
                                    <h4 class="no-margin">Shipping</h4>
                                    <p class="pt-10">
                                        The following shipping operators are supported.
                                    </p>
                                    <div class="providers">
                                        <img src="assets/img/logos/brands/ups.svg" alt="" />
                                        <img src="assets/img/logos/brands/usps.svg" alt="" />
                                        <img src="assets/img/logos/brands/fedex.svg" alt="" />
                                        <img src="assets/img/logos/brands/aramex.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>  */}
                        {/* <div class="flex-card simple-shadow">
                            <div class="card-body">
                                <div class="content">
                                    <h4 class="no-margin">Payment</h4>
                                    <p class="pt-10">
                                        The following payment providers are supported.
                                    </p>
                                    <div class="providers">
                                        <img src="assets/img/logos/brands/paypal.svg" alt="" />
                                        <img src="assets/img/logos/brands/stripe.svg" alt="" />
                                        <img src="assets/img/logos/brands/visa.svg" alt="" />
                                        <img src="assets/img/logos/brands/mastercard.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-card simple-shadow">
                            <div class="card-body">
                                <div class="content">
                                    <h4 class="no-margin">Benefits</h4>
                                    <p class="pt-10">
                                        The following additional benefits are available on purchase of
                                        this product.
                                    </p>
                                    <div class="is-flex is-align-items-center py-1">
                                        <div class="is-flex is-justify-content-center is-align-items-center is-circle bg-grey">
                                            <i class="sl sl-icon-check success-text"></i>
                                        </div>
                                        <div class="ml-2">
                                            <p>30-Day money back</p>
                                        </div>
                                    </div>
                                    <div class="is-flex is-align-items-center py-1">
                                        <div class="is-flex is-justify-content-center is-align-items-center is-circle bg-grey">
                                            <i class="sl sl-icon-check success-text"></i>
                                        </div>
                                        <div class="ml-2">
                                            <p>1 Year warranty</p>
                                        </div>
                                    </div>
                                    <div class="is-flex is-align-items-center py-1">
                                        <div class="is-flex is-justify-content-center is-align-items-center is-circle bg-grey">
                                            <i class="sl sl-icon-check success-text"></i>
                                        </div>
                                        <div class="ml-2">
                                            <p>24/24 Customer service</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div class="product-footer">
                    <div class="footer-title">
                        <h2>Other Products</h2>
                    </div>
                    
                            <Sliders data={related} />
                       
                </div>
            </div>
        </div>
    </div>
  )
}

export default Product
